import React from "react";
import { TruncatedCell } from "../../../common";

export const showUserInformation = (
  columnTitles,
  { fullName, amountOfKudos }
) => {
  return (
    <>
      <thead>
        <tr>
          {columnTitles.map((columnTitle, index) => (
            <th key={index} style={{ whiteSpace: "nowrap" }}>{columnTitle}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="truncate-col">
            <TruncatedCell text={fullName} />
          </td>
          <td style={{ whiteSpace: "nowrap" }}>{amountOfKudos}</td>
        </tr>
      </tbody>
    </>
  );
};
